<template>
  <div>
    <el-form ref="queryForm" :inline="true">
      <el-form-item>
        <el-button
          :v-permisaction="[exportP]"
          type="primary"
          icon="el-icon-download"
          size="mini"
          :loading="loading"
          @click="exportData()"
        >{{ exportTitle }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'

export default {
  name: 'OneExport',
  props: {
    exportP: {
      type: String,
      required: false
    },
    queryParams: {
      type: Object,
      default: () => {}
    },
    exportTitle: {
      type: String,
      default: '导出'
    },
    exportMethod: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile'
    }
  },
  methods: {
    exportData() {
      this.loading = true
      this.exportMethod(this.queryParams).then(res => {
        if (res.code === 200) {
          this.loading = false
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
